// store/useCompanyStore.js
import {
  isIdentical,
  isObjectEmpty,
  joinParameters,
  parseRFC3339,
  validArray,
} from "data/functions";
import { translations } from "data/globals";
import { create } from "zustand";
import { persist } from "zustand/middleware";

const useJobStore = create(
  persist(
    (set, get) => ({
      jobList: [],
      jobTime: {},
      // pushJobList: (job) => {
      //   if (isObjectEmpty(job)) return;
      //   if (!job.timestamp) job.timestamp = new Date(Date.now()).toISOString();

      //   let merged = joinParameters(get().jobList, job, []);
      //   // merged = validArray(merged).sort(
      //   //   (a, b) =>
      //   //     parseRFC3339(a?.timestamp || 0) - parseRFC3339(b?.timestamp || 0),
      //   // );
      //   if ((merged?.length || 0) >= 15) merged = merged.slice(-15);
      //   if (!isIdentical(merged, get()?.jobList)) set({ jobList: merged });
      // },
      pushJobList: (job) => {
        if (isObjectEmpty(job)) return;
        if (!job.timestamp) job.timestamp = new Date(Date.now()).toISOString();

        const currentList = get().jobList;
        const existingIndex = currentList.findIndex(
          (item) => item.uuid === job.uuid,
        );

        let newList;
        if (existingIndex === -1) {
          newList = [job, ...currentList];
        } else {
          newList = [...currentList];
          newList[existingIndex] = job;
        }

        if (newList.length > 15) {
          newList = newList.slice(0, 15);
        }

        if (!isIdentical(newList, currentList)) {
          set({ jobList: newList });
        }
      },

      getJob: (value) =>
        validArray(get().jobList)?.find((job) => {
          return job?.uuid === value;
        }),

      deleteFromJobList: (uuid) => {
        if (!uuid) return;
        set((state) => ({
          jobList: validArray(state.jobList).filter(
            (job) => job?.uuid !== uuid,
          ),
        }));
      },
    }),
    {
      name: "job-storage",
      partialize: (state) =>
        Object.fromEntries(
          Object.entries(state).filter(
            ([key, value]) => typeof value !== "function" && key !== "",
          ),
        ),
    },
  ),
);

export default useJobStore;
